import type { DeleteAssetsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteAssetsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteAssets = createMutationHook({
  name: 'deleteAssets',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.asset.delete.mutationOptions({ onSuccess }),
  mapInput: (variables: { Ids: string[] }) => ({ Ids: variables.Ids }),
  invalidate: (trpc) => [
    trpc.frontend.asset.register.queryKey(),
    trpc.frontend.asset.assetById.queryKey(),
  ],
  mapResponse: (
    _result,
    variables: { Ids: string[] }
  ): DeleteAssetsMutation => ({
    deleteAssetsById: {
      __typename: 'GenericMutationOutput',
      affected_rows: variables.Ids.length,
    },
  }),
  graphqlDocument: DeleteAssetsDocument,
  graphqlVariables: (variables: { Ids: string[] }) => ({ Ids: variables.Ids }),
  evictFields: ['asset', 'asset_aggregate'],
});
